<template>
    <div v-show="!props.hide">
        <sp-form
            class="mobile-general-form-order"
            :class="`uuid-${config.uuid} ${globalModel.preview ? 'preview-text' : ''} ${notChanged ? 'disable-opacity' : ''}`"
            ref="elForm"
            v-show="!props.hide"
            :model="formModel"
            :rules="rules"
        >
            <sp-form-item prop="liveWorkData">
                <sharp-comp-select
                    :label="i18nLabel"
                    :selected-options-text="selectedOptionsText"
                    :is-required="props.required && !globalModel.preview"
                    :readonly="globalModel.preview || globalModel.hideSubmitStyle"
                    @click="onClick"
                    :placeholder="dealPlaceHolder"
                ></sharp-comp-select>
                <div :class="['sp-form-item__error', errorMsg && 'has-error-msg']">
                    {{ errorMsg }}
                </div>
            </sp-form-item>
        </sp-form>
        <csc-card
            class="show-card"
            :class="{'card-error': errorMsg}"
            v-if="showDetailData"
            :showData="showLiveData"
            :showDetailData="showDetailData"
        >
        </csc-card>
        <PickerPanel
            v-model="showPanel"
            :title="panelTitle"
            :customStyle="customPickerStyle"
            customClass="live-work-picker"
            :showBack="showPanelBack"
            @back-click="onPanelBack"
        >
            <div v-show="!selectedUser" class="picker-content">
                <CscTabPanel
                    ref="tab-list"
                    class="live-tab"
                    :tabList="tabArray"
                    :forceRender="showPanel"
                    :selectIndex="activeIndex"
                    :defaultIndex="0"
                    :isShowUnread="false"
                    @tabSelect="tabSelect"
                ></CscTabPanel>
                <div v-show="activeIndex === 0" class="recent-content">
                    <csc-list
                        :list="recentList"
                        :emptyText="selectConfig.emptyText"
                        :emptyIcon="selectConfig.emptyIcon"
                        :showLoading="showLoading"
                        class="recent-user-list"
                        @get-more-data="getMoreRecentData"
                    >
                        <div class="live-item" v-for="(item, index) in recentList" :key="index">
                            <csc-base-live-card
                                :showHeadImage="isLive"
                                :liveCardInfo="item"
                                :showTitleCaption="!isLive"
                                @chooseClick="workItemClick"
                            ></csc-base-live-card>
                        </div>
                        <div
                            v-if="hasMoreData"
                            v-io
                            class="list-loading"
                            @exposed="getMoreRecentData"
                        ></div>
                    </csc-list>
                </div>
                <SearchPage
                    v-show="activeIndex === 1"
                    @userSelect="onUserItemClick"
                    @on-no-result-click="onNoResult"
                    ref="searchPage"
                >
                </SearchPage>
                <no-result-btn @on-no-result-click="onNoResult" v-if="activeIndex === 0"></no-result-btn>
            </div>
            <SelectedUser
                v-if="selectedUser"
                :showSelf="showSelf"
                :showAll="showAll"
                :selected-user="selectedUser"
                :selected-config="selectConfig"
                @work-item-click="workItemClick"
                @on-no-result-click="onNoResult"
            >
            </SelectedUser>
        </PickerPanel>
        <sub-title class="mt16 error-right" v-if="lastShowRejectTip(i18nLabel)" :errorMsg="outputError(i18nLabel)"></sub-title>
    </div>
</template>
<script>
import { Form, FormItem } from '@ks/sharp-ui';
import SharpCompSelect from '@ks/sharp-comp-form-select';
import '@ks/sharp-comp-form-select/lib/themes/default/index.css';
import PickerPanel from '../component-base/common/picker-panel';
import NoResultBtn from '../component-base/common/no-result-btn';
import isEqual from 'lodash/isEqual';
import CscDesign from '@ks-csc/mobile-design';
import ComponentBase from '../component-base';
import { component, PHOTO_SHOW_TYPE } from './props';
import SearchPage from './search-page.vue';
import SelectedUser from './select-user.vue';
import { CONFIGS, getUserId } from './data-util';
import IntersectionObserve from '../../utils/directives/intersection-observe';
import formEventBus, { FORM_EVENTS_TYPE } from '../../utils/event-bus';
import { fetchUserDetail } from '../mobile-general-form-user-select/util';
import { RESULT_FALLBACK_VALUE } from '../../const';
import SubTitle from '../component-base/common/sub-title';

const { CscTabPanel, CscList, CscBaseLiveCard, CscCard } = CscDesign;
export default {
    name: component,
    directives: {
        io: IntersectionObserve,
    },
    components: {
        SpForm: Form,
        SpFormItem: FormItem,
        SharpCompSelect,
        PickerPanel,
        CscTabPanel,
        CscList,
        CscBaseLiveCard,
        CscCard,
        SearchPage,
        SelectedUser,
        NoResultBtn,
        SubTitle,
    },
    extends: ComponentBase,
    data() {
        return {
            formModel: {
                liveWorkData: '',
            },
            isLive: this.originConfig.output === 'selectLive',
            selectConfig: CONFIGS[this.originConfig.output],
            customPickerStyle: {
                maxHeight: '85%',
                minHeight: '85%',
            },
            showPanel: false,
            showLoading: false,
            hasMoreData: false,
            errorMsg: '',
            selectedOptionsText: '',
            activeIndex: 0,
            recentPage: 0,
            selectedUser: undefined,
            tabArray: CONFIGS[this.originConfig.output].tabArray,
            panelTitle: CONFIGS[this.originConfig.output].panelTitle,
            recentList: [],
            showLiveData: {},
            showDetailData: undefined,
        };
    },
    computed: {
        rules() {
            return {
                liveWorkData: this.composeRules(this.props),
            };
        },
        placeholder() {
            const hasData = this.formModel.liveWorkData && (this.formModel.liveWorkData.photoId || this.formModel.liveWorkData.liveId);
            return hasData ? this.props.selectedPlaceholder : this.props.placeholder;
        },
        showPanelBack() {
            return !!this.selectedUser && !this.showSelf;
        },
        showSelf() {
            return !this.isLive && [PHOTO_SHOW_TYPE.SELF_ALL, PHOTO_SHOW_TYPE.SELF_PUBLIC].includes(this.props.showWho);
        },
        showAll() {
            return !this.isLive && this.props.showWho === PHOTO_SHOW_TYPE.SELF_ALL;
        },
        dealPlaceHolder() {
            if (this.globalModel.noticeFormPreview && this.formModel.liveWorkData && (this.formModel.liveWorkData.photoId || this.formModel.liveWorkData.liveId)) {
                return this.formModel.liveWorkData.photoId || this.formModel.liveWorkData.liveId;
            }
            return !this.globalModel.preview && !this.globalModel.hideSubmitStyle ? this.i18n(this.placeholder) : '';
        },
    },
    watch: {
        'formModel.liveWorkData': {
            immediate: true,
            handler(liveWorkData) {
                if (this.dataValid(liveWorkData)) {
                    this.selectedOptionsText = '';
                    this.fetchDetail(liveWorkData);
                }
                if (liveWorkData && (liveWorkData.photoId === RESULT_FALLBACK_VALUE || liveWorkData.liveId === RESULT_FALLBACK_VALUE)) {
                    this.selectedOptionsText = '没有我想选择的内容';
                }
            },
        },
        panelShow(val) {
            formEventBus.$emit(FORM_EVENTS_TYPE.IS_OPEN_PICKER, val);
        },
        showSelf: {
            immediate: true,
            async handler(val) {
                if (val) {
                    const targetUserId = getUserId();
                    if (!targetUserId) {
                        // Toast.error('请在快手APP中打开！');
                        return;
                    }
                    const { data } = await fetchUserDetail({
                        targetUserId,
                        pageType: 13, // 13 才返回粉丝数
                    });
                    this.selectedUser = data;
                }
            },
        },
    },
    methods: {
        dataValid(liveWorkData) {
            if (!liveWorkData) {return false;}
            if (liveWorkData.photoId) {
                return liveWorkData.photoId !== RESULT_FALLBACK_VALUE;
            }
            if (liveWorkData.liveId) {
                return liveWorkData.liveId !== RESULT_FALLBACK_VALUE;
            }
            return false;
        },
        onNoResult() {
            this.showDetailData = undefined;
            this.formModel.liveWorkData = {
                photoId: RESULT_FALLBACK_VALUE,
                liveId: RESULT_FALLBACK_VALUE,
            };
            this.selectedOptionsText = '没有我想选择的内容';
            this.onPickerValueChange();
            this.$emit('user-input');
            this.showPanel = false;
        },
        onPanelBack() {
            this.selectedUser = undefined;
        },
        async onUserItemClick(item) {
            this.selectedUser = item;
        },
        async fetchRecentList() {
            const { hasMore, list } = await this.selectConfig.getRecentList({
                offset: this.recentPage * 10,
            });
            this.recentList = [...this.recentList, ...list];
            // const a = [];
            // for (let i = 0; i < 20; i++) {
            //     a.push(this.recentList[0]);
            // }
            // this.recentList = a;
            this.hasMoreData = hasMore;
            this.recentPage += 1;
        },
        workItemClick(item) {
            this.showLiveData = this.selectConfig.getCardData(item);
            this.showDetailData = item;
            this.formModel.liveWorkData = item;
            this.onPickerValueChange();
            this.$emit('user-input');
            this.showPanel = false;
        },
        getMoreRecentData() {
            this.fetchRecentList();
        },
        tabSelect(item) {
            this.activeIndex = item.value;
            if (this.activeIndex === 1) {
                this.$nextTick(() => {
                    this.$refs.searchPage && this.$refs.searchPage.updateHistoryTags();
                });
            }
        },
        async fetchDetail(liveWorkData) {
            this.showLiveData = this.selectConfig.getCardData(liveWorkData);
            this.showDetailData = liveWorkData;
        },
        async onClick() {
            if (!this.onClickForm()) {return;}
            this.showPanel = true;
        },
        onPickerValueChange() {
            const res = this.setSelfFormDataValue(this.formModel.liveWorkData);
            if (res) {
                // 数据修改成功，抛出change 事件，触发依赖
                this.$emit('change');
            }
        },
        /**
         * 以下是组件公共方法的实现
         */
        dataChangeHandler() {
            const newValue = this.getSelfFormDataValue();
            if (typeof newValue === 'undefined') {
                // 默认值逻辑
                this.formModel.liveWorkData = '';
                this.onPickerValueChange('');
                // this.validate();
                return;
            }

            if (!isEqual(this.formModel.liveWorkData, newValue)) {
                this.formModel.liveWorkData = newValue;
                // 数据被动修改同样抛出change事件
                this.$emit('change');
                // this.validate();
            }
        },
        async validate() {
            if (this.skipValidate()) {
                return true;
            }
            if (!this.formModel.liveWorkData && this.props.required) {
                const errorMsg = this.i18n(this.props.errRequired, this.i18nLabel) || `${this.i18nLabel}不能为空`;
                this.errorMsg = errorMsg;
                this.validateFailureHandler(errorMsg);
                return false;
            }
            const promise = new Promise((resolve, reject) => {
                this.$refs.elForm.validate((valid, invalidFields) => {
                    valid ? resolve(valid) : reject(invalidFields);
                });
            });
            try {
                this.errorMsg = '';
                return await promise;
            } catch (e) {
                this.errorMsg = e.liveWorkData[0].message;
                this.validateFailureHandler(e.liveWorkData[0].message);
                return false;
            }
        },
        clearValidate() {
            this.errorMsg = '';
            this.$refs.elForm && this.$refs.elForm.clearValidate();
        },
    },
    async mounted() {
        await this.fetchRecentList();
    },
};
</script>

<style lang="less" scoped>
@import '../../style.less';
.picker-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .recent-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: auto;
    }
}
.list-loading {
    width: 0.3rem;
    height: 0.3rem;
    margin: 0 auto;
    background: var(--csc-collect-list-loading) no-repeat;
    background-size: contain;
}
.live-tab {
    /deep/ .tabs-item {
        color: var(--font-notice, #9c9c9c) !important;
    }
    /deep/ .is-active {
        color: var(--font-common, #222) !important;
    }
    border-bottom: .5px solid var(--bg-problem-divider, #eaeaea) !important;
}

.recent-user-list {
    margin: 0.18rem 0.15rem 0 0.15rem;
    overflow: auto;
  /deep/ .no-data {
    margin-top: 172px;
  }
  /deep/ .k-loading {
    margin-top: 172px;
  }
  /deep/ .list {
        display: flex;
        flex-wrap: wrap;
        .live-card {
            background-color: var(--button-bg, #fff) !important;
            .content {
                .csc-image img {
                    object-fit: cover;
                    position: static;
                    transform: none;
                    border-radius: 50%;
                    &::after {
                        display: none;
                    }
                }
            }
        }
    }
}
.show-card {
    margin: 0 19px;
    margin-bottom: 18px;
    margin-top: -6px;
    border-radius: 8px;
    background: #F8F8F8;
    /deep/ .card-physical {
        margin-top: 0 !important;
        .csc-image {
            border-radius: 8px;
            & > img {
                object-fit: cover;
            }
        }
        .detail-item {
            &:first-of-type {
                .item {
                    color: var(--font-common, #222) !important;
                }
            }
            .item {
                    color: #9c9c9c !important;
                }
        }
    }
}
.card-error {
    margin-top: 16px;
}
.live-item {
    margin: 0 0.04rem 0.08rem;
    width: 1.84rem;
}
.input-wrapper {
    width: 100%;
    height: 40px;
    padding: 10px 12px;
    margin: 0 19px;
    border-radius: 20px;
    background: red;
    color: var(--font-common,#222);
}
/deep/.sp-form-item__content {
    .sp-form-item__error {
        left: 0;
        right: auto;
    }
    .sp-form-item__error:not(.has-error-msg) {
        display: none !important;
    }
}
</style>
